import { Component } from '@angular/core';
import { SharedService } from '../../shared/shared.service';
import { ActivatedRoute } from '@angular/router';
import { take } from 'rxjs';
import { LoaderService } from '../../core/services/loader.service';
@Component({
  selector: 'app-payment-success',
  templateUrl: './payment-success.component.html',
  styleUrl: './payment-success.component.scss',
  standalone: false,
})
export class PaymentSuccessComponent {
  queryParams: any = {};
  constructor(
    private sharedService: SharedService,
    private route: ActivatedRoute,
    private loaderService: LoaderService
  ) {}

  ngOnInit(): void {
    this.loaderService.setLoading(true);
    console.log('Waiting for query params...');
    this.route.queryParams.pipe(take(1)).subscribe((params) => {
      if (Object.keys(params).length === 0) {
        console.warn('No query params found in URL.');
        return;
      }

      this.queryParams = { ...params };
      console.log('Query Params Received:', this.queryParams);
      this.sharedService.PaymentLink_Success(this.queryParams).subscribe({
        next: (res) => {
          //if (res.statusCode == 200) {
          this.loaderService.setLoading(false);
          console.log('API Success Response:', res);
          //}
        },
        error: (err) => {
          console.error('API Error:', err);
          this.loaderService.setLoading(false);
        },
      });
    });
  }
}
